<!-- Modal Backdrop -->
<div class="blur-modal-backdrop"
     [class.fade-in]="!isClosing"
     [class.fade-out]="isClosing"
     (click)="onBackdropClick($event)">
</div>

<!-- Modal -->
<div class="mantis-modal"
     role="dialog"
     aria-modal="true"
     [class.modal-in]="!isClosing"
     [class.modal-out]="isClosing">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h5 class="mb-0 fw-bold">Manage members</h5>
            <button class="btn-close" type="button" (click)="onClose()" title="Close">
                <img src="assets/common/ic_x_s_size.svg" alt="Close" />
            </button>
        </div>

        <div class="users-count">{{ (total || memberCount) }} members</div>

        <div class="users-search">
            <i class="ti ti-search"></i>
            <input type="text"
                   class="form-control"
                   placeholder="Search members"
                   [(ngModel)]="searchQuery"
                   (ngModelChange)="onSearchInput()">
        </div>

        <div class="users-list">
            @if (isLoading) {
                <div class="users-list-loading">
                    <span>Loading...</span>
                </div>
            } @else {
                @for (member of members; track member.id) {
                    <div class="user-item">
                        <div class="user-avatar">
                            @if (member.avatar) {
                                <img [src]="member.avatar" [alt]="member.name" class="avatar-image">
                            } @else {
                                <div class="avatar-circle">
                                    <span class="avatar-initials">{{ getInitials(member.name) }}</span>
                                </div>
                            }
                        </div>
                        
                        <div class="user-info">
                            <div class="user-name">{{ member.name }}</div>
                            @if (getMemberDisplayLine(member)) {
                                <div class="user-email">{{ getMemberDisplayLine(member) }}</div>
                            }
                        </div>
                        
                        <div class="user-actions">
                            <button *ngIf="member.role !== 'owner'" class="btn-icon-sm btn-icon-new-tab" type="button" title="Open client profile" (click)="onOpenMemberProfile(member)">
                                <img src="assets/common/ic_new_tab.svg" alt="New tab">
                            </button>
                            <button *ngIf="member.role !== 'owner'" class="btn-icon-sm" type="button" title="Message client" (click)="onOpenDirectChat(member)">
                                <img src="assets/messaging/ic_new_message.svg" alt="New message">
                            </button>
                            <button class="btn-icon-sm btn-icon-remove" type="button" title="Remove member" (click)="onRemoveMember(member)">
                                <img src="assets/common/ic_delete_destructive.svg" alt="Delete">
                            </button>
                        </div>
                    </div>
                }
                
                @if (!isLoading && members.length === 0) {
                    <div class="empty-state">
                        <h6 class="empty-state-title">No members added yet</h6>
                        <p class="empty-state-description">This group chat doesn't have any members yet. Add users to start the conversation.</p>
                    </div>
                }
            }
        </div>

        @if (lastPage > 1) {
            <div class="pagination-container">
                <nav aria-label="Users pagination">
                    <ul class="pagination pagination-sm justify-content-center mb-0">
                        <li class="page-item" [class.disabled]="currentPage === 1">
                            <a class="page-link"
                               (click)="onPageChange(currentPage - 1)"
                               [attr.aria-disabled]="currentPage === 1">
                                Previous
                            </a>
                        </li>
                        @for (page of getPaginationPages(); track page) {
                            <li class="page-item" [class.active]="page === currentPage">
                                @if (page === '...') {
                                    <span class="page-link">...</span>
                                } @else {
                                    <a class="page-link"
                                       (click)="onPaginationPageClick(page)">
                                        {{ page }}
                                    </a>
                                }
                            </li>
                        }
                        <li class="page-item" [class.disabled]="currentPage === lastPage">
                            <a class="page-link"
                               (click)="onPageChange(currentPage + 1)"
                               [attr.aria-disabled]="currentPage === lastPage">
                                Next
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        }

        <div class="modal-footer d-flex justify-content-between align-items-center gap-2">
            <button class="btn btn-outline-secondary" type="button" (click)="onAddNew()">
                <i class="ti ti-plus"></i>
                Add new
            </button>
            <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
                Close
            </button>
        </div>
    </div>
</div>
